import { Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { AuthGate } from './lib/auth';
import { Layout } from './components/Layout';
import { FullPageLoader } from './components/ui';

const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const LeadsList = lazy(() => import('./pages/LeadsList'));
const LeadDetail = lazy(() => import('./pages/LeadDetail'));
const RdvList = lazy(() => import('./pages/RdvList'));
const RdvDetail = lazy(() => import('./pages/RdvDetail'));
const Supervision = lazy(() => import('./pages/Supervision'));
const Settings = lazy(() => import('./pages/Settings'));
const NotFound = lazy(() => import('./pages/NotFound'));

const Loader = () => <FullPageLoader />;

export default function App() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <AuthGate>
              <Layout />
            </AuthGate>
          }
        >
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/leads" element={<LeadsList />} />
          <Route path="/leads/:id" element={<LeadDetail />} />
          <Route path="/rdv" element={<RdvList />} />
          <Route path="/rdv/:id" element={<RdvDetail />} />
          <Route path="/supervision" element={<Supervision />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
